module.exports = __webpack_public_path__ + "static/media/close.5e5c37e0.svg";